import React from "react";
import NewsFeedAll from "../../components/newsFeed";

const NewsAll = () => {
  return <NewsFeedAll />;
};

export default NewsAll;
